import React from "react";
import classNames from "classnames";
import Container from "reactstrap/lib/Container";
import withStyles from "react-jss";

const styles = (theme) => ({
	root: {
		display: "flex",
		justifyContent: "flex-start",
		alignItems: "center",
		marginBottom: "60px",
	},
	header: {},
	sortWrapper: {
		marginLeft: "auto",
		width: "280px",
	},
	orientationChanger: {
		marginLeft: "20px",
	},
	buttonWrapper: {
		width: "280px",
		marginRight: "auto",
	},
	isStub: {
		"& $header": {
			width: "150px",
			borderRadius: "10px",
			height: "16px",
			backgroundColor: theme.palette.colors.disabled,
		},
	},
	hideButton: {
		display: "none",
	},
	btnHide: {},
	highMargin: {},
	[`@media (min-width: ${theme.media.md}) and (max-width: ${theme.media.lg})`]: {
		buttonWrapper: {
			width: "300px",
		},
		sortWrapper: {
			width: "300px",
		},
	},
	[`@media (min-width: ${theme.media.sm}) and (max-width: ${theme.media.md})`]: {
		root: {
			marginBottom: "40px",
		},
		buttonWrapper: {
			width: "auto",
		},
		sortWrapper: {
			width: "230px",
		},
	},
	[`@media (max-width: ${theme.media.sm})`]: {
		root: {
			justifyContent: "center",
			marginBottom: "20px",
			flexWrap: "wrap-reverse",
		},
		sortWrapper: {
			marginRight: 0,
			width: "100%",
		},
		buttonWrapper: {
			marginTop: "20px",
			width: "100%",
		},
		orientationChanger: {
			display: "none",
		},
		btnHide: {
			display: "none",
		},
		highMargin: {
			marginBottom: "32px",
		},
	},
});

class Sort extends React.PureComponent {
	render() {
		let classes = this.props.classes;
		return (
			<Container>
				<div
					className={classNames(classes.root, {
						[classes.isStub]: this.props.stub,
						[classes.highMargin]: this.props.highMargin,
					})}
				>
					<div
						className={classNames(classes.buttonWrapper, {
							[classes.btnHide]: this.props.isButtonHide,
							[classes.hideButton]: this.props.hideButton,
						})}
					>
						{this.props.button}
					</div>
					<div className={classes.sortWrapper}>{this.props.sort}</div>
					{!!this.props.orientationChanger && (
						<div className={classes.orientationChanger}>{this.props.orientationChanger}</div>
					)}
				</div>
			</Container>
		);
	}
}

export default withStyles(styles)(Sort);
